export default __webpack_public_path__ + "static/eth@2x-9f4f8447566556ede039b0157ffe679e.png";